import React from 'react';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import $ from 'jquery';

class DiscoverForm extends React.Component {
    constructor(props) {
        super(props);
        this.changeEnvironment = this.changeEnvironment.bind(this);
        this.changePipelineIntegration = this.changePipelineIntegration.bind(this);
        this.changePipeline = this.changePipeline.bind(this);

        let environmentOptions = [];
        let pipelineIntegrationOptions = [];
        let pipelineOptions = [];

        let preSelectedDatasource = this.props.preSelectedDatasource;
        let preSelectedEnv = this.props.preSelectedEnv;
        let preSelectedDataset = this.props.preSelectedDataset;

        let envId;
        let pipelineIntegrationId;
        // let pipelineId;

        for (let [key, value] of Object.entries(this.props.nestedData)) {
            environmentOptions.push({ "label": value["title"], "value": key });
        }

        let environment = this.props.envCount;


        envId = this.props.selectedEnv !== null ? this.props.selectedEnv.value : this.props.latest_env_id;

        let pipelineIntegrations = this.props.nestedData !==undefined && this.props.nestedData[envId] !==undefined && this.props.nestedData[envId]["childNodes"];
        for (let [key, value] of Object.entries(pipelineIntegrations)) {
            pipelineIntegrationOptions.push({ "label": value["title"], "value": key });
        }

        let pipelineIntegration = this.props.pipelineIntegrationCount;
        if (pipelineIntegration === null) {
            let filterPipelineIntegration = this.props.filterResultData.filter(value => {
                return value.type === "Datasource"; // Assuming Datasource type for Pipeline Integration
            });
            pipelineIntegration = filterPipelineIntegration.length;
        } else if (preSelectedDatasource) {
          
          pipelineIntegrationId = preSelectedDatasource?.value;

        let pipelines =
        this.props.nestedData?.[envId]?.childNodes?.[pipelineIntegrationId]?.childNodes;

        if (pipelines && typeof pipelines === "object") {
        for (let [key, value] of Object.entries(pipelines)) {
            pipelineOptions.push({ label: value.title, value: key });
        }
        }

        }

        let pipeline = this.props.pipelineCount;
        if (pipeline === null) {
            let filteredPipeline = this.props.filterResultData.filter(value => {
                return value.type === "Pipeline";
            });
            pipeline = filteredPipeline.length;
        } else if (preSelectedDataset) {
            // pipelineId = preSelectedDataset["value"];
        }

        this.state = {
            environmentOptions: environmentOptions,
            pipelineOptions: pipelineOptions,
            pipelineIntegrationOptions: pipelineIntegrationOptions,
            selectedPipelineIntegration: preSelectedDatasource,
            selectedPipeline: preSelectedDataset,
            selectedEnv: preSelectedEnv,
            totalenvironment: environment,
            totalpipeline: pipeline,
            totalpipelineIntegration: pipelineIntegration,
        };
    }

    changeEnvironment(event) {
        let envId = event.value;
        let pipelineIntegrations = this.props.nestedData[envId];

        let pipelineIntegrationOptions = [];
        if (pipelineIntegrations !== undefined) {
            pipelineIntegrations = pipelineIntegrations["childNodes"];
            for (let [key, value] of Object.entries(pipelineIntegrations)) {
                pipelineIntegrationOptions.push({ "label": value["title"], "value": key });
            }
            this.props.applyFilter("Environment", event);

            let pipelineIntegration = this.props.filterResultData.filter(value => {
                return value.type === "Datasource" && value.envId.toLowerCase().slice(0, envId) === envId;
            });
            let pipeline = this.props.filterResultData.filter(value => {
                return value.type === "Pipeline" && value.envId.toLowerCase().slice(0, envId) === envId;
            });
            this.props.changeCount(1, pipelineIntegration.length, pipeline.length);

            this.setState({
                pipelineIntegrationOptions: pipelineIntegrationOptions,
                selectedPipelineIntegration: null,
                selectedPipeline: null,
                pipelineOptions: [],
                selectedEnv: event,
                totalenvironment: 1,
                totalpipeline: pipeline.length,
                totalpipelineIntegration: pipelineIntegration.length,
            });
        }
        $("#filtericon").hide();
        $(".filter-count").html(1);
        $(".filter-count").show();
        $("#btn-filter").addClass("active");
    }

    changePipelineIntegration(event) {
        let envId = this.props.selectedEnv !== null ? this.props.selectedEnv.value : this.props.latest_env_id;
        let pipelineIntegrationId = event.value;
        let pipelineOptions = [];
        let pipelines = this.props.nestedData[envId]["childNodes"][pipelineIntegrationId];
        if (pipelines !== undefined) {
            pipelines = pipelines["childNodes"];
            for (let [key, value] of Object.entries(pipelines)) {
                pipelineOptions.push({ "label": value["title"], "value": key });
            }
            this.props.applyFilter("Datasource", this.props.selectedEnv !== null ? this.props.selectedEnv.value : this.props.latest_env_id, event);
            
            let data = {
              "name": event.label,
              "id": Number(pipelineIntegrationId),
              "type": "Datasource",
              "envId": envId,
              "envName": "Environment",
              "datasourceId": Number(pipelineIntegrationId),
              "datasourceName": this.state.selectedPipelineIntegration.label,
            }
            this.props.renderSearchData(data);
            let id = "#-left-panel-div-";
            id = id + pipelineIntegrationId;
            $(id).trigger("click");

            let pipeline = this.props.filterResultData.filter(value => {
                return value.type === "Pipeline" && value.datasourceId.toLowerCase().slice(0, pipelineIntegrationId) === pipelineIntegrationId;
            });

            this.props.changeCount(1, 1, pipeline.length);
            this.setState({
                pipelineOptions: pipelineOptions,
                selectedPipelineIntegration: event,
                selectedPipeline: null,
                totalpipeline: pipeline.length,
                totalpipelineIntegration: 1,
            });
        }
        $(".filter-count").html(2);
    }

    changePipeline(event) {
        let envId = this.props.selectedEnv !== null ? this.props.selectedEnv.value : this.props.latest_env_id;
        let pipelineIntegrationId = this.state.selectedPipelineIntegration.value;


        let pipelineId = Number(event.value);
        this.props.applyFilter("Dataset", this.props.selectedEnv !== null ? this.props.selectedEnv.value : this.props.latest_env_id, this.state.selectedPipelineIntegration, event);
        $('#Pipeline-left-panel-div-').trigger("click");
        this.setState({ selectedPipeline: event, totalpipeline: 1 });
        this.props.changeCount(1, 1, 1);
        $(".filter-count").html(3);
        let data = {
          "name": event.label,
          "id": pipelineId,
          "datasetId": pipelineId,
          "pipelineId": pipelineId,
          "type": "Dataset",
          "envId": envId,
          "envName": "Environment",
          "datasourceId": Number(pipelineIntegrationId),
          "datasourceName": this.state.selectedPipelineIntegration.label,
          "datasetName": event.label
        }
        this.props.closeAdvancedFilter(data);
        this.props.renderSearchData(data);
    }

    render() {
        return (
            <>
                <div className="qd_search-filter-form">
                    <Form className="form-label-right-md" data-select2-id="28">
                        <h4 className="qd_autosuggest-title">Advanced search</h4>
                        <button onClick={this.props.closeAdvancedFilter} type="button" className="btn btn-link">Close</button>
                        <div className="row row-sm" data-select2-id="27">
                            {/* <Form.Group controlId="environment" className="col-6">
                                <Form.Label>Environment :</Form.Label>
                                <Select name="environment"
                                    filterOption={({ label }, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="environment"
                                    options={this.state.environmentOptions}
                                    onChange={this.changeEnvironment}
                                    placeholder={this.props.selectedEnv !== null ? this.props.selectedEnv.label : this.props.latest_env_name}
                                    classNamePrefix='select-control'
                                    value={this.state.selectedEnv}
                                    isDisabled
                                />
                            </Form.Group> */}
                            <Form.Group controlId="pipelineIntegration" className="col-6">
                                <Form.Label>Pipeline Integration :</Form.Label>
                                <Select name="pipelineIntegration"
                                    filterOption={({ label }, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="pipelineIntegration"
                                    options={this.state.pipelineIntegrationOptions}
                                    onChange={this.changePipelineIntegration}
                                    placeholder="Select Pipeline Integration"
                                    classNamePrefix='select-control'
                                    value={this.state.selectedPipelineIntegration}
                                />
                            </Form.Group>
                            <Form.Group controlId="pipeline" className="col-6">
                                <Form.Label>Pipeline :</Form.Label>
                            <Select name="dataset"
                                    filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="dataset"
                                    options={this.state.pipelineOptions}
                                    onChange={this.changePipeline}
                                    placeholder="Select Dataset"
                                    classNamePrefix='select-control'
                                    value={this.state.selectedPipeline}
                            />
                        </Form.Group>
                    </div>
                    </Form>
                    <div className="qd_search-rst-footer">
                        <ol className="qd_tab-separated-block">
                        {/* <li className="tab-separated-value"><span><strong>{this.state.totalenvironment}</strong> Environment</span></li> */}
                        <li className="tab-separated-value"><span><strong>{this.state.pipelineIntegrationOptions.length}</strong> Pipeline Integration</span></li>
                        <li className="tab-separated-value"><span><strong>{this.state.pipelineOptions.length}</strong> Pipeline Job</span></li>
                        {/* <li className="tab-separated-value"><span><strong>{this.state.totalattibute}</strong> Attributes</span></li> */}
                        </ol></div>
                        </div></>);




    }
}

export default DiscoverForm;
















